<template>
    <div class="topic_modify_items innerTopic">
      <div class="avatar_info avatar">
        <div class="topic_modify_user_avatar" @click="goToUserCenter">
          <!-- <img class="txk" :src="avatarIcon" alt="" v-if="avatarIcon"> -->
          <img src="avatar" :src="avatar" alt="">
        </div>
  
        <div class="topic_modify_user_info" @click="goToUserCenter">
          <div class="g_line1">
            {{ nickname }} 
            <!-- <img :src="vipIcon" alt="" v-if="vipIcon">
            <img :src="medalIcon" alt="" v-if="medalIcon"> -->
          </div>
          <!-- <div class="create_time-tag">
            <span>{{ publishTime }}</span>
          </div> -->
          <div class="create_time-tag">
            <span v-if="publishTime">{{ publishTime.slice(0, 11) }}</span>
            <div class="tags_area" v-if="label&&label.length > 0">
              <div class="tag" v-if="label.length > 0">
                <span v-for="(item,i) in label" :key="i">
                  {{ item }}
                </span>
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </div>
  </template>
  
  <script type="text/javascript">
  import TopicMix from "./TopicMix";
  
  export default {
    name: "topic-user",
    mixins: [TopicMix],
    data() {
      return {
        followState: null,
        following: 0
      };
    },
    props: {
      tiny: Boolean,
      avatar: String,
      nickname: String,
      // 楼层
      floor: [String, Number],
      date: String,
      isFollow: null,
      publishTime: String,
      label: Array
    },
    computed: {
      isLogin() {
        return this.$store.getters.isLogin
      }
    },
    methods: {
      handleDropdown(name) {
        switch (name) {
          case "report":
            this.doReport();
            break;
          case "share":
            this.doShare();
            break;
        }
      },
      // 关注用户
      handleFollowUser() {
        if (isLogin) {
          this.following++;
          this.$store
            .dispatch("follow", {
              type: "user",
              id: this.userId,
              follow: this.followState
            })
            .then(() => {
              this.followState = !this.followState;
            })
            .finally(() => {
              this.following--;
            });
        } else {
          this.$mypopup({
            onSuccess: () => {
              this.following++;
              this.$store
                .dispatch("follow", {
                  type: "user",
                  id: this.userId,
                  follow: this.followState
                })
                .then(() => {
                  this.followState = !this.followState;
                })
                .finally(() => {
                  this.following--;
                });
            }
          })
        }
      },
      // 仅用在主楼层
      doReply() {
        if (this.isLogin) {
          if (this.replyId > 0) {
            this.$RModal.reply({
              afterTitle: this.nickname,
              selection: {
                topicId: this.topicId,
                postId: 0,
                id: this.replyId
              },
              onSuccess: () => {
                this.$parent.$emit("on-reply");
              }
            });
          }
        } else {
          this.$mypopup({
            onSuccess: () => {
              if (this.replyId > 0) {
                this.$RModal.reply({
                  afterTitle: this.nickname,
                  selection: {
                    topicId: this.topicId,
                    postId: 0,
                    id: this.replyId
                  },
                  onSuccess: () => {
                    this.$parent.$emit("on-reply");
                  }
                });
              }
            }
          })
        }
      },
      doReport() {
        if (this.isLogin) {
          this.$RModal.report({
            afterTitle: this.nickname,
            selection: {
              topicId: this.topicId,
              replyId: this.replyId
            }
          });
        } else {
          this.$mypopup({
            onSuccess: () => {
              this.$RModal.report({
                afterTitle: this.nickname,
                selection: {
                  topicId: this.topicId,
                  replyId: this.replyId
                }
              });
            }
          })
        }
      }
    },
    watch: {
      isFollow: {
        immediate: true,
        handler(b) {
          this.followState = b;
        }
      }
    }
  };
  </script>
  <style lang="less" scoped>
    .innerTopic {
      padding: 0 !important;
    }
    .avatar_info {
    display: flex;
    align-items: center;
    margin-bottom: .8rem;

    .topic_modify_user_avatar {
      margin-right: 1.05rem;
      height: 2.1rem;
      position: relative;
      cursor: pointer;

      .avatar,
      img {
        width: 2.1rem;
        height: 2.1rem;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .txk {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 2.5rem;
        height: 2.5rem;
        transform: translate(-50%, -50%);
        z-index: 2;
        border-radius: unset;
      }

      .van-image__loading {
        border-radius: 50%;
      }
    }

    .topic_modify_user_info {
        display: flex;
        flex-direction: column;
 
        justify-content: space-between;
      .g_line1 {
        font-weight: 700;
        font-size: .7rem;
        white-space: nowrap;
        cursor: pointer;
        display: flex;
        align-items: center;
      }

      img {
        margin-left: .15rem;
        height: .7rem;
      }

      .medal_icon {
        height: 1.3rem;
        transform: translateY(0.05rem);
      }

      .create_time-tag {
        font-size: 0.6rem;
        color: #878787;
        display: flex;
        align-items: center;

        .tags_area {
          display: flex;
          align-items: center;
          margin-left: 0.4rem;
          border-left: 1px solid #ddd;
          padding-left: 0.4rem;
          height: 0.6rem;

          span {
            margin-right: 0.6rem;
          }

          .tag {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
  </style>
  